document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-index')) return;

  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 50);
  });
});
document.addEventListener('DOMContentLoaded', () => {
  // Remove all zoom buttons/icons
  document.querySelectorAll('.media-zoom').forEach(el => el.remove());

  // Remove overlay pseudo-elements & prevent hover zoom
  document.querySelectorAll('.product__media-wrapper').forEach(wrapper => {
    wrapper.style.cursor = 'default';
    wrapper.classList.remove('media-zoom'); // in case Dawn re-adds it
  });

  // Optional: prevent future dynamically added zoom buttons
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.classList && node.classList.contains('media-zoom')) {
          node.remove();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

